export default __webpack_public_path__ + "static/media/Att.526112cc.png";